'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { NpsG2Modal } from '@workspace/ui/components/g2-review/nps-g2-modal';
import { useNpsModal } from '@workspace/ui/components/g2-review/use-nps-modal';
import { useCallback, useEffect } from 'react';
import { getG2ReviewUrl, submitNpsFeedback } from '@/actions/nps';
import { useAuthStore } from '@/stores/authStore';
import { useNpsStore } from '@/stores/npsStore';

/**
 * Gates the NPS modal using the access token's has_completed_nps claim.
 * We sync that into the NPS store and only show the modal when the user
 * has not completed the survey (and has not dismissed it this session).
 *
 * Modal will NOT show if any of these are true:
 * 1. NEXT_PUBLIC_G2_ENABLED !== 'true'
 * 2. No user (not logged in)
 * 3. Token has_completed_nps is true or user completed this session
 * 4. User dismissed the modal within the past 14 days (localStorage-backed, survives page refresh)
 */
export function NpsG2Wrapper() {
  const user = useAuthStore((state) => state.user);
  const email = user?.user?.email ?? '';
  const isEnabled = process.env.NEXT_PUBLIC_G2_ENABLED === 'true';

  const isNpsLoaded = useNpsStore((state) => state.isLoaded);
  const isNpsCompleted = useNpsStore((state) => state.isCompleted);
  const isDismissed = useNpsStore((state) => state.isDismissed);
  const syncFromAuth = useNpsStore((state) => state.syncFromAuth);

  useEffect(() => {
    if (isEnabled && user) {
      syncFromAuth(user);
    }
  }, [isEnabled, user, syncFromAuth]);

  const shouldShow = isEnabled && !!email && isNpsLoaded && !isNpsCompleted && !isDismissed;

  if (!shouldShow) return null;

  return <NpsG2ModalInner email={email} />;
}

/** Inner component — only mounts when server confirms user hasn't completed a survey */
function NpsG2ModalInner({ email }: { email: string }) {
  const { isOpen, closeModal } = useNpsModal();
  const markCompleted = useNpsStore((state) => state.markCompleted);
  const markDismissed = useNpsStore((state) => state.markDismissed);

  const handleGetG2ReviewUrl = useCallback(() => getG2ReviewUrl(), []);

  return (
    <NpsG2Modal
      isOpen={isOpen}
      onClose={closeModal}
      onCompleted={markCompleted}
      onDismissed={markDismissed}
      userEmail={email}
      getG2ReviewUrl={handleGetG2ReviewUrl}
      submitFeedback={submitNpsFeedback}
      feedbackLoadingText={'Loading'}
      surveyName="In-app NPS"
    />
  );
}

export default NpsG2Wrapper;
